<template>
    <div id="app">
        <p v-if="greeting">
          <span id="greeting">{{ greeting }}</span><br/>
        </p>
        <p>
            I’m Lee Nugent, a software engineering manager based in London, originally from the beautiful city of Newcastle upon Tyne.
        </p>

        <p>
            Currently I’m helping <a href="http://gousto.co.uk" target="_blank">Gousto</a> become the UK’s most loved way to eat dinner. Before that I worked at <a href="http://383project.com" target="_blank">383</a>,
            helping some of the UK’s biggest brands get fit for the future.
        </p>

        <p>
            I am passionate about building happy, engaged & performant product focused teams.
        </p>

        <p>
            Want to get in touch? Follow me on <a href="http://twitter.com/leenug" target="_blank">Twitter</a> & <a
                href="http://instagram.com/leenug" target="_blank">Instagram</a> or just drop me an <a
                href="mailto:lee@leenug.com">email</a>.
        </p>

        <p id="small-print">
            <span id="divider"></span>
            &copy;{{ new Date().getFullYear() }} Lee Nugent. Hosted on AWS, from London with <span class="love">&#9829;</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {
                'greeting': '',
                'greetings': [
                    "hello",
                    "hey there",
                    "howdy"
                ],
            }
        },
        mounted() {
            let index = Math.floor(Math.random() * this.greetings.length);
            this.greeting = this.greetings[index];
        }
    }
</script>

<style lang="scss">

    $primary: #e30bb1;
    $gray: #989898;
    $love: #8e3838;

    #wrap {
        height: 100%;
        width: 100vw;
    }

    body {
        background-color: #fff;
        color: #323232;
    }

    #app {
        font-family: 'Avenir Next', Helvetica, Arial, sans-serif;
        font-weight: bold;
        width: 60%;
        font-size: 2em;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        margin-top: 30px;
        margin-left: 30px;

        a {
            color: $primary;
            text-decoration: none;
            padding: 0 5px;

            &:hover {
                background: $primary;
                color: #ffffff;
            }
        }

        #greeting {
            background: $primary;
            color: #ffffff;
            padding: 0 5px;
        }

        em {
            text-decoration: none;
            color: #ccc;
            font-style: normal;
        }

        #small-print {
            font-size: 0.4em;
            color: $gray;
            font-weight: 400;

            .love {
                color: $love;
            }

            #divider {
                width: 75px;
                display: block;
                border-bottom: 1px dotted $gray;
                margin: 20px 0px 25px 0px;
            }
        }
    }
    
    @media (prefers-color-scheme: dark) {
        body {
            background-color: #313131;
            color: #D1D1D1;

            #profile {
                img {
                    filter: grayscale(100%);

                    &:hover {
                        -webkit-filter: none;
                        filter: none;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 600px) {
        #app {
            width: auto;
            margin: 10px;
            font-size: 1.7em;

            #profile {
                width: 50px;
                height: 50px;
                top: 20px;
                right: 20px;
                position: absolute;

                img {
                    width: 50px;
                    height: 50px;
                }
            }
        }
    }
</style>
